import { isClientLoggedIn } from './clientAuth.js'

/** Navega a la vista dedicada /cliente (sin apilar sobre landing). */
export function openClientLoginModal({ navigate } = {}) {
  if (isClientLoggedIn()) {
    navigate?.('/mi-instalacion')
    return
  }
  navigate?.('/cliente')
}

export function closeClientLoginModal() {
  /* noop — login en ruta dedicada */
}

export function clientLoginButtonHtml() {
  return `<a href="/cliente" data-link class="support-header-btn support-header-btn--primary">
    <span class="support-header-btn-ico" aria-hidden="true">👤</span> Cliente
  </a>`
}

export function wireClientLoginButtons(root, { navigate }) {
  root.querySelectorAll('[data-client-login]').forEach((btn) => {
    btn.addEventListener('click', (ev) => {
      ev.preventDefault()
      if (isClientLoggedIn()) {
        navigate('/mi-instalacion')
        return
      }
      navigate('/cliente')
    })
  })
}
